export const handleRollOverModalToggle = () => {
  const rollOverToggler = document.getElementById("custom-rollover-button");

  rollOverToggler.dataset.toggle = "modal";
  rollOverToggler.dataset.target = "#principalOrInterestModal";
  rollOverToggler.click();
};

export const InvestmentStatus = {
  ACTIVE: "Active",
  CLOSED: "Closed",
};
